<div fxLayout="column" [ngStyle]="{'max-height.px': innerHeight}" fxFlexFill>

    <div fxLayoutAlign="center center" class="layout-padd">
        <img style="height: 120px;" [ngStyle.xs]="{'height' : '100px'}" src="assets/img/dialogs/basket-test.png">
    </div>

    <div fxLayoutAlign="center center" class="layout-padd text-center">

        <span class="mat-subheading-1" *ngIf="!from">{{"dialogs.preventlosspan.order" |
      translate}}</span>
        <span class="mat-subheading-1" *ngIf="from">{{"dialogs.preventlosspan.pan" | translate}}</span>

    </div>

    <div *ngIf="!from" class="layout-padd" fxLayout="row" fxLayout.xs="column" fxLayoutGap="10px">

        <button mat-stroked-button color="accent" (click)="close('macommande')" angulartics2On="click" angularticsAction="recoverCurrentOrder" angularticsCategory="preventLossPointOfSale" fxFlex="50">
      <span>{{"dialogs.myorder" | translate}}</span>
    </button>

        <button mat-stroked-button color="primary" (click)="close('continue')" angulartics2On="click" angularticsAction="beginNewOrder" angularticsCategory="preventLossPointOfSale" fxFlex="50">
      <span>{{"dialogs.neworder" | translate}}</span>
    </button>

    </div>

    <div *ngIf="from" class="layout-padd" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">

        <button mat-stroked-button color="warn" (click)="close()" angulartics2On="click" angularticsAction="recoverCurrentOrder" angularticsCategory="preventLossPointOfSale" fxFlex="50">{{"dialogs.go-back" |
      translate}}</button>

        <button mat-stroked-button color="accent" (click)="close('continue')" fxFlex="50" angulartics2On="click" angularticsAction="beginNewOrder" angularticsCategory="preventLossPointOfSale">
      {{"dialogs.continue" | translate}}
    </button>

    </div>

</div>